function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
import { Container } from "../Container/index.js";
import { NavItem } from "../NavItem/index.js";
import { Typography } from "../Typography/index.js";
const columnClasses = 'w-grid-1 md:w-grid-2 lg:w-auto lg:grow pt-10 md:pt-12';
const promoClasses = 'basis-1/2 py-8 md:py-12 border-b border-white bottom:border-t md:border-r last:border-r-0 md:border-b-0';
/**
 * Footer - [API](https://scl.sharp.com/?path=/docs/components-footer) | [DSM](https://sharphealthcare.notion.site/Footer-b5fe4d5c3db2400abe2666dcb20f9133)
*/ const Footer = /*#__PURE__*/ forwardRef((_param, ref)=>{
    var { column1, column2, column3, column4, promo1, promo2, subFooterText, subFooterLinks } = _param, props = _object_without_properties(_param, [
        "column1",
        "column2",
        "column3",
        "column4",
        "promo1",
        "promo2",
        "subFooterText",
        "subFooterLinks"
    ]);
    return /*#__PURE__*/ _jsxs("footer", _object_spread_props(_object_spread({}, props), {
        ref: ref,
        children: [
            (column1 || column2 || column3 || column4) && /*#__PURE__*/ _jsx("div", {
                className: "bg-gray-50",
                children: /*#__PURE__*/ _jsxs(Container, {
                    as: "nav",
                    className: "flex flex-wrap gap-x-5 pb-8",
                    children: [
                        column1 && /*#__PURE__*/ _jsx("div", {
                            className: columnClasses,
                            children: column1
                        }),
                        column2 && /*#__PURE__*/ _jsx("div", {
                            className: columnClasses,
                            children: column2
                        }),
                        column3 && /*#__PURE__*/ _jsx("div", {
                            className: columnClasses,
                            children: column3
                        }),
                        column4 && /*#__PURE__*/ _jsx("div", {
                            className: columnClasses,
                            children: column4
                        })
                    ]
                })
            }),
            (promo1 || promo2) && /*#__PURE__*/ _jsx("div", {
                className: "bg-primary-50",
                children: /*#__PURE__*/ _jsxs(Container, {
                    className: "flex flex-col md:flex-row gap-x-5 justify-evenly",
                    children: [
                        promo1 && /*#__PURE__*/ _jsx("div", {
                            className: promoClasses,
                            children: promo1
                        }),
                        promo2 && /*#__PURE__*/ _jsx("div", {
                            className: promoClasses,
                            children: promo2
                        })
                    ]
                })
            }),
            (subFooterText || subFooterLinks) && /*#__PURE__*/ _jsx("div", {
                className: "bg-gray-50",
                children: /*#__PURE__*/ _jsxs(Container, {
                    className: "grid grid-cols-12 py-6 gap-x-5 gap-y-4 items-start",
                    ref: ref,
                    children: [
                        subFooterText && /*#__PURE__*/ _jsx("div", {
                            className: "col-span-12 lg:col-span-8 xl:col-span-9",
                            children: /*#__PURE__*/ _jsx(Typography, {
                                variant: "small-body",
                                children: subFooterText
                            })
                        }),
                        subFooterLinks && /*#__PURE__*/ _jsx("div", {
                            className: "col-span-12 lg:col-span-4 xl:col-span-3 text-gray-700",
                            children: /*#__PURE__*/ _jsx("div", {
                                className: "flex justify-start lg:justify-end lg:whitespace-nowrap divide-x [&>*]:px-2 -mx-2",
                                children: subFooterLinks === null || subFooterLinks === void 0 ? void 0 : subFooterLinks.map((link)=>/*#__PURE__*/ _jsx(NavItem, _object_spread({}, link), link.href))
                            })
                        })
                    ]
                })
            })
        ]
    }));
});
export { Footer };
